<article [ngClass]="'content-panel--' + color()" class="content-panel">
  <ng-content />
</article>
